import { fontConstants } from '../constants';

const initialState = {
    loading: false,
    fonts: [],
    error: null,
    uploadingFont: false,
    uploadError: null,
    updatingFont: false,
    updateError: null,
};

const fontReducer = (state = initialState, action) => {
    switch (action.type) {
        case fontConstants.FETCH_ALLFONTS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case fontConstants.FETCH_ALLFONTS_SUCCESS:
            return {
                ...state,
                loading: false,
                fonts: action.fonts,
                error: null
            };
        case fontConstants.FETCH_ALLFONTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case fontConstants.UPLOAD_FONT_REQUEST:
            return {
                ...state,
                uploadingFont: true,
                uploadError: null,
            };
        case fontConstants.UPLOAD_FONT_SUCCESS:
            return {
                ...state,
                uploadingFont: false,
                fonts: action.fonts
            };
        case fontConstants.UPLOAD_FONT_FAILURE:
            return {
                ...state,
                uploadingFont: false,
                uploadError: action.payload,
            };
        case fontConstants.UPDATE_FONT_REQUEST:
            return {
                ...state,
                updatingFont: true,
                updateError: null,
            };
        case fontConstants.UPDATE_FONT_SUCCESS:
            return {
                ...state,
                fonts: action.fonts,
                updatingFont: false,
                updateError: null,
            };
        case fontConstants.UPDATE_FONT_FAILURE:
            return {
                ...state,
                updatingFont: false,
                updateError: action.payload,
            };
        case fontConstants.DELETE_FONT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case fontConstants.DELETE_FONT_SUCCESS:
            return {
                ...state,
                loading: false,
                fonts: state.fonts.filter(f => f.FontId !== action.payload),
            };
        case fontConstants.DELETE_FONT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default fontReducer;
